export const GLOBAL_CONFIG_PAGE_SIZE = {
  pageSizeDefault: 10, // Số mục trên mỗi trang
  pageDefault: 0,
  pageSizeOptions: [10, 20, 50, 100, 200], // Tùy chọn kích thước trang,
};
